// Analytics Configuration Constants
// Centralized configuration for all tracking IDs and analytics settings

export const ANALYTICS_CONFIG = {
  // Google Analytics 4 (GA4) Tracking ID
  GA4_TRACKING_ID: 'G-BL9YHFH9X6',
  
  // Google Tag Manager ID
  GTM_ID: 'GTM-TJXHKT2',
  
  // ReactGA Tracking ID (Universal Analytics - deprecated but still used in some components)
  REACTGA_TRACKING_ID: 'UA-121546945-2',
  
  // Segment Write Key (from environment variable)
  SEGMENT_WRITE_KEY: process.env.GATSBY_SEGMENT_WRITE_KEY || '',
  
  // Analytics Settings
  SETTINGS: {
    // Enable debug mode for development
    DEBUG_MODE: process.env.NODE_ENV === 'development',
    
    // Respect Do Not Track
    RESPECT_DNT: true,
    
    // Anonymize IP addresses
    ANONYMIZE_IP: true,
    
    // Cookie expiration (0 = session only)
    COOKIE_EXPIRES: 0,
    
    // Delay for route updates (in milliseconds)
    ROUTE_UPDATE_DELAY: 0
  }
};

// Helper function to get the current tracking ID based on environment
export const getTrackingId = (): string => {
  return ANALYTICS_CONFIG.GA4_TRACKING_ID;
};

// Helper function to check if analytics should be enabled
export const isAnalyticsEnabled = (): boolean => {
  // Disable analytics in development unless explicitly enabled
  if (process.env.NODE_ENV === 'development' && !ANALYTICS_CONFIG.SETTINGS.DEBUG_MODE) {
    return false;
  }
  
  // Respect Do Not Track
  if (typeof window !== 'undefined' && navigator.doNotTrack === '1') {
    return false;
  }
  
  return true;
};

// Helper function to get analytics configuration for current environment
export const getAnalyticsConfig = () => {
  return {
    ...ANALYTICS_CONFIG,
    enabled: isAnalyticsEnabled()
  };
};
